// extracted by mini-css-extract-plugin
export default {"wrapper":"css_wrapper__K02zM","text":"css_text__rcryr"};